import React, { useState } from 'react';
import ScrollReveal from '../components/common/ScrollReveal';

function Contacto() {
  const [formData, setFormData] = useState({
    subject: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      // Cambiamos a HTTPS y enviamos solo los datos del formulario básicos
      const response = await fetch('https://toyo-esports-backend.vercel.app/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          subject: formData.subject,
          email: formData.email,
          message: formData.message
        })
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({ type: 'success', message: '¡Mensaje enviado con éxito!' });
        setFormData({ subject: '', email: '', message: '' });
      } else {
        throw new Error(data.message || 'Error al enviar el mensaje');
      }
    } catch (error) {
      setStatus({ type: 'error', message: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-dark">
      <div className="container mx-auto px-4 py-16 lg:py-24">
        <ScrollReveal>
          <div className="max-w-2xl mx-auto bg-brand-dark/50 rounded-xl p-8 backdrop-blur-sm shadow-xl">
            <div className="text-center mb-10">
              <h1 className="text-6xl md:text-7xl font-morganite text-brand-white tracking-wider">
                CONTACTO
              </h1>
              <div className="h-1 w-24 bg-brand-peach mx-auto mt-4 rounded-full"/>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              {status.message && (
                <div className={`p-4 rounded-lg ${
                  status.type === 'error' 
                    ? 'bg-brand-red/10 border border-brand-red text-brand-red'
                    : 'bg-green-500/10 border border-green-500 text-green-500'
                } transition-all duration-300`}>
                  <p className="font-helvetica text-sm">{status.message}</p>
                </div>
              )}

              <div className="space-y-2">
                <label htmlFor="subject" className="block text-sm font-medium text-brand-peach">
                  Asunto
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 bg-brand-dark/50 border border-brand-peach/20 rounded-lg 
                           text-brand-white placeholder-brand-white/50 focus:outline-none 
                           focus:border-brand-peach transition-colors duration-200"
                  placeholder="Escribe el asunto de tu mensaje"
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="email" className="block text-sm font-medium text-brand-peach">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 bg-brand-dark/50 border border-brand-peach/20 rounded-lg 
                           text-brand-white placeholder-brand-white/50 focus:outline-none 
                           focus:border-brand-peach transition-colors duration-200"
                  placeholder="tu@email.com"
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="message" className="block text-sm font-medium text-brand-peach">
                  Mensaje
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows={6}
                  className="w-full px-4 py-3 bg-brand-dark/50 border border-brand-peach/20 rounded-lg 
                           text-brand-white placeholder-brand-white/50 focus:outline-none 
                           focus:border-brand-peach transition-colors duration-200 resize-none"
                  placeholder="Escribe tu mensaje aquí..."
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full px-6 py-3 bg-brand-peach text-brand-dark rounded-lg 
                         font-medium hover:bg-brand-peach/90 focus:outline-none 
                         focus:ring-2 focus:ring-brand-peach focus:ring-offset-2 
                         focus:ring-offset-brand-dark disabled:opacity-50 
                         disabled:cursor-not-allowed transition-all duration-200"
              >
                {loading ? 'Enviando...' : 'Enviar mensaje'}
              </button>
            </form>
          </div>
        </ScrollReveal>
      </div>
    </div>
  );
}

export default Contacto;